<template>
  <div class="security-log-panel" v-loading="loading">
    <section class="panel-header">
      <div>
        <h3>安全校验日志</h3>
        <p>ford_security_check_log</p>
      </div>

      <el-button :icon="Refresh" plain :loading="loading" @click="fetchLogs">
        刷新
      </el-button>
    </section>

    <section class="filter-section">
      <el-form label-position="top" class="filter-form">
        <div class="filter-grid">
          <el-form-item label="服务器">
            <el-select v-model="filters.server" class="full-control">
              <el-option
                v-for="server in serverOptions"
                :key="server.value"
                :label="server.label"
                :value="server.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="时间范围">
            <el-date-picker
              v-model="filters.dateRange"
              type="datetimerange"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="YYYY-MM-DD HH:mm:ss"
              class="date-range"
            />
          </el-form-item>

          <el-form-item label="结果">
            <el-select v-model="filters.success" class="full-control">
              <el-option label="失败" value="0" />
              <el-option label="成功" value="1" />
              <el-option label="全部" value="all" />
            </el-select>
          </el-form-item>

          <el-form-item label="功能">
            <el-select v-model="filters.funcType" class="full-control">
              <el-option label="全部" value="all" />
              <el-option label="SecurityOffline" value="1" />
              <el-option label="SecurityOL" value="5" />
            </el-select>
          </el-form-item>

          <el-form-item label="SN">
            <el-input v-model.trim="filters.sn" clearable @keyup.enter="handleSearch" />
          </el-form-item>

          <el-form-item label="VIN">
            <el-input v-model.trim="filters.vin" clearable @keyup.enter="handleSearch" />
          </el-form-item>

          <el-form-item label="模块地址">
            <el-input v-model.trim="filters.modAddr" clearable @keyup.enter="handleSearch" />
          </el-form-item>

          <el-form-item label="安全类型">
            <el-select v-model="filters.securityType" class="full-control">
              <el-option label="全部" value="all" />
              <el-option label="3V3" value="3V3" />
              <el-option label="4V4" value="4V4" />
              <el-option label="16V16" value="16V16" />
              <el-option label="UNKNOWN" value="UNKNOWN" />
            </el-select>
          </el-form-item>

          <el-form-item label="计算来源">
            <el-select v-model="filters.calcSource" class="full-control" filterable>
              <el-option
                v-for="source in sourceOptions"
                :key="source.value"
                :label="source.label"
                :value="source.value"
              />
            </el-select>
          </el-form-item>
          <div class="filter-actions">
            <el-button :icon="Refresh" plain @click="resetFilters">重置</el-button>
            <el-button type="primary" :icon="Search" :loading="loading" @click="handleSearch">
              查询
            </el-button>
            <el-button type="warning" plain :icon="Refresh" :loading="loading" @click="refetchCurrentPage">
              重新请求
            </el-button>
            <el-button
              type="success"
              plain
              :icon="Download"
              :loading="downloadingTxt"
              :disabled="loading || downloadingTxt || total <= 0 || !lastSuccessfulQuery"
              @click="downloadTxt"
            >
              下载TXT
            </el-button>
          </div>
        </div>

      </el-form>
    </section>

    <section class="stats-strip">
      <div class="stat-item">
        <span>匹配记录</span>
        <strong>{{ total }}</strong>
      </div>
      <div class="stat-item">
        <span>主要来源</span>
        <strong>{{ topSourceText }}</strong>
      </div>
      <div class="stat-item">
        <span>主要类型</span>
        <strong>{{ topTypeText }}</strong>
      </div>
      <div class="stat-item">
        <span>当前页</span>
        <strong>{{ tableData.length }}</strong>
      </div>
    </section>

    <section class="table-section">
      <div class="section-heading">
        <div>
          <h4>明细</h4>
          <p>{{ currentFilterText }}</p>
        </div>
      </div>

      <el-table
        :data="tableData"
        border
        stripe
        size="small"
        class="security-table"
        max-height="520"
        empty-text="暂无安全校验日志"
      >
        <el-table-column type="expand" width="42">
          <template #default="{ row }">
            <div class="security-row-detail">
              <div class="detail-grid">
                <div class="detail-item detail-item-wide">
                  <span>Request ID</span>
                  <el-button link type="primary" class="detail-link" @click="openRequestDrawer(row)">
                    {{ row.request_id || '-' }}
                  </el-button>
                </div>
                <div class="detail-item">
                  <span>SafeBytes</span>
                  <strong class="mono-value">{{ row.safe_bytes || '-' }}</strong>
                </div>
                <div class="detail-item">
                  <span>SecurityData</span>
                  <strong class="mono-value">{{ row.security_data || '-' }}</strong>
                </div>
                <div class="detail-item">
                  <span>SafeBytes Len</span>
                  <strong>{{ row.safe_bytes_len || 0 }}</strong>
                </div>
                <div class="detail-item">
                  <span>原始 AssyPN</span>
                  <strong class="mono-value">{{ row.assy_pn_raw || '-' }}</strong>
                </div>
                <div class="detail-item detail-item-wide">
                  <span>错误信息</span>
                  <strong>{{ row.error_message || '-' }}</strong>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="结果" width="64" align="center">
          <template #default="{ row }">
            <el-tag :type="Number(row.success) === 1 ? 'success' : 'danger'" effect="light">
              {{ Number(row.success) === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="created_at" label="时间" width="160" show-overflow-tooltip />
        <el-table-column label="功能" width="104">
          <template #default="{ row }">{{ funcTypeLabel(row.func_type) }}</template>
        </el-table-column>
        <el-table-column prop="security_type" label="类型" width="68" align="center" />
        <el-table-column label="来源" width="92">
          <template #default="{ row }">
            <el-tag :type="sourceTagType(row.calc_source)" effect="plain">
              {{ sourceLabel(row.calc_source) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sn" label="SN" width="112" show-overflow-tooltip />
        <el-table-column prop="vin" label="VIN" width="150" show-overflow-tooltip />
        <el-table-column prop="mod_addr" label="Addr" width="60" align="center" />
        <el-table-column prop="assy_pn" label="AssyPN" min-width="136" show-overflow-tooltip />
        <el-table-column prop="assy_pn_index" label="PN#" width="50" align="center" />
        <el-table-column prop="sub_level" label="Level" width="56" align="center" />
      </el-table>

      <div class="pagination-row">
        <el-pagination
          v-model:current-page="page"
          v-model:page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next"
          :page-sizes="[20, 50, 100, 200]"
          :total="total"
          @size-change="handlePageSizeChange"
          @current-change="fetchLogs"
        />
      </div>
    </section>

    <el-drawer
      v-model="requestDrawerVisible"
      :title="activeRequestId || 'Request ID'"
      size="72%"
      destroy-on-close
    >
      <div v-loading="requestLoading" class="request-drawer">
        <el-table
          :data="requestRows"
          border
          stripe
          size="small"
          class="request-table"
          empty-text="暂无同请求记录"
        >
          <el-table-column label="结果" width="78" align="center">
            <template #default="{ row }">
              <el-tag :type="Number(row.success) === 1 ? 'success' : 'danger'" effect="light">
                {{ Number(row.success) === 1 ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="时间" width="176" />
          <el-table-column prop="assy_pn_index" label="PN#" width="62" align="center" />
          <el-table-column prop="assy_pn" label="AssyPN" min-width="160" show-overflow-tooltip />
          <el-table-column prop="calc_source" label="来源" width="112" />
          <el-table-column prop="security_type" label="类型" width="86" align="center" />
          <el-table-column prop="safe_bytes" label="SafeBytes" min-width="170" show-overflow-tooltip />
          <el-table-column prop="security_data" label="SecurityData" min-width="150" show-overflow-tooltip />
          <el-table-column prop="error_message" label="错误信息" min-width="260" show-overflow-tooltip />
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { Download, Refresh, Search } from '@element-plus/icons-vue';

import { getFordSecurityCheckLogs } from '@/api/users';

const serverOptions = [
  { label: 'CN Server', value: 'CN Server' },
  { label: 'US Server', value: 'US Server' },
];

const sourceOptions = [
  { label: '全部', value: 'all' },
  { label: 'FDRS DLL', value: 'fdrs_dll' },
  { label: 'IDS DLL', value: 'ids_dll' },
  { label: 'JMC 内置', value: 'jmc_builtin' },
  { label: '3V3 Tool', value: 'tool_3v3' },
  { label: 'fallback', value: 'fallback' },
  { label: 'IDS fallback', value: 'ids_fallback' },
  { label: 'validate', value: 'validate' },
  { label: 'product_limit', value: 'product_limit' },
];

const sourceLabelMap = new Map(sourceOptions.map((item) => [item.value, item.label]));

const filters = reactive({
  server: 'CN Server',
  dateRange: defaultDateRange(),
  success: '0',
  funcType: 'all',
  sn: '',
  vin: '',
  modAddr: '',
  securityType: 'all',
  calcSource: 'all',
});

const loading = ref(false);
const tableData = ref([]);
const total = ref(0);
const page = ref(1);
const pageSize = ref(50);
const sourceStats = ref([]);
const securityTypeStats = ref([]);
const requestDrawerVisible = ref(false);
const requestLoading = ref(false);
const downloadingTxt = ref(false);
const lastSuccessfulQuery = ref(null);
const activeRequestId = ref('');
const requestRows = ref([]);

const txtColumns = [
  { key: 'id', label: 'id' },
  { key: 'request_id', label: 'request_id' },
  { key: 'created_at', label: 'created_at' },
  { key: 'func_type', label: 'func_type', formatter: funcTypeLabel },
  { key: 'sn', label: 'sn' },
  { key: 'vin', label: 'vin' },
  { key: 'diag_id', label: 'diag_id' },
  { key: 'diag_version', label: 'diag_version' },
  { key: 'mod_addr', label: 'mod_addr' },
  { key: 'assy_pn_raw', label: 'assy_pn_raw' },
  { key: 'assy_pn', label: 'assy_pn' },
  { key: 'assy_pn_index', label: 'assy_pn_index' },
  { key: 'sub_level', label: 'sub_level' },
  { key: 'safe_bytes', label: 'safe_bytes' },
  { key: 'safe_bytes_len', label: 'safe_bytes_len' },
  { key: 'security_type', label: 'security_type' },
  { key: 'calc_source', label: 'calc_source' },
  {
    key: 'success',
    label: 'success',
    formatter: (value) => (Number(value) === 1 ? 'success' : 'failed'),
  },
  { key: 'security_data', label: 'security_data' },
  { key: 'error_message', label: 'error_message' },
];

const topSourceText = computed(() => statText(sourceStats.value, sourceLabel));
const topTypeText = computed(() => statText(securityTypeStats.value, (value) => value || '-'));

const currentFilterText = computed(() => {
  const status = filters.success === '0' ? '失败' : (filters.success === '1' ? '成功' : '全部');
  const func = filters.funcType === 'all' ? '全部功能' : funcTypeLabel(filters.funcType);
  return `${filters.server} / ${status} / ${func}`;
});

function pad(value) {
  return String(value).padStart(2, '0');
}

function formatDate(date) {
  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
  ].join('-') + ' ' + [
    pad(date.getHours()),
    pad(date.getMinutes()),
    pad(date.getSeconds()),
  ].join(':');
}

function defaultDateRange() {
  const end = new Date();
  const start = new Date(end.getTime() - 24 * 60 * 60 * 1000);
  return [formatDate(start), formatDate(end)];
}

function statText(rows, formatter) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return '-';
  }
  const first = rows[0];
  return `${formatter(first.name)} ${first.count || 0}`;
}

function sourceLabel(value) {
  return sourceLabelMap.get(value) || value || '-';
}

function sourceTagType(value) {
  if (value === 'fdrs_dll' || value === 'ids_dll') {
    return 'success';
  }
  if (value === 'fallback' || value === 'ids_fallback') {
    return 'danger';
  }
  if (value === 'validate' || value === 'product_limit') {
    return 'warning';
  }
  return 'info';
}

function funcTypeLabel(value) {
  const n = Number(value);
  if (n === 1) {
    return 'SecurityOffline';
  }
  if (n === 5) {
    return 'SecurityOL';
  }
  return String(value || '-');
}

function pickPayload(response) {
  return response?.data?.data || response?.data || {};
}

function txtCell(value) {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value).replace(/[\t\r\n]+/g, ' ').trim();
}

function rowToTxtLine(row) {
  return txtColumns.map((column) => {
    const value = column.formatter ? column.formatter(row[column.key], row) : row[column.key];
    return txtCell(value);
  }).join('\t');
}

function buildTxtContent(rows) {
  const header = txtColumns.map((column) => column.label).join('\t');
  const body = rows.map(rowToTxtLine);
  return [header, ...body].join('\r\n');
}

function downloadTextFile(content, filename) {
  const blob = new Blob([`\uFEFF${content}`], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function downloadFileName() {
  const timestamp = formatDate(new Date()).replace(/[-:]/g, '').replace(/\s+/g, '_');
  return `ford_security_check_log_${timestamp}.txt`;
}

function buildQueryParams(extra = {}) {
  const [startAt, endAt] = Array.isArray(filters.dateRange) ? filters.dateRange : [];
  return {
    page: page.value,
    page_size: pageSize.value,
    success: filters.success,
    func_type: filters.funcType,
    sn: filters.sn,
    vin: filters.vin,
    mod_addr: filters.modAddr,
    security_type: filters.securityType,
    calc_source: filters.calcSource,
    start_at: startAt,
    end_at: endAt,
    ...extra,
  };
}

async function fetchLogs() {
  loading.value = true;
  try {
    const queryParams = buildQueryParams();
    const response = await getFordSecurityCheckLogs(filters.server, queryParams);
    const payload = pickPayload(response);
    tableData.value = Array.isArray(payload.tableData) ? payload.tableData : [];
    total.value = Number(payload.total || 0);
    sourceStats.value = Array.isArray(payload.sourceStats) ? payload.sourceStats : [];
    securityTypeStats.value = Array.isArray(payload.securityTypeStats) ? payload.securityTypeStats : [];
    lastSuccessfulQuery.value = {
      server: filters.server,
      params: { ...queryParams },
    };
  } catch (error) {
    ElMessage.error('查询安全校验日志失败');
  } finally {
    loading.value = false;
  }
}

async function fetchAllRowsForDownload() {
  const rows = [];
  const exportPageSize = 500;
  let exportPage = 1;
  let expectedTotal = Number(total.value || 0);
  const query = lastSuccessfulQuery.value || {
    server: filters.server,
    params: buildQueryParams(),
  };

  do {
    const response = await getFordSecurityCheckLogs(query.server, {
      ...query.params,
      page: exportPage,
      page_size: exportPageSize,
    });
    const payload = pickPayload(response);
    const pageRows = Array.isArray(payload.tableData) ? payload.tableData : [];
    rows.push(...pageRows);
    expectedTotal = Number(payload.total || expectedTotal || rows.length);

    if (pageRows.length < exportPageSize) {
      break;
    }
    exportPage += 1;
  } while (rows.length < expectedTotal);

  return rows;
}

async function downloadTxt() {
  if (total.value <= 0) {
    ElMessage.warning('没有可下载的安全校验日志');
    return;
  }

  downloadingTxt.value = true;
  try {
    const rows = await fetchAllRowsForDownload();
    if (rows.length === 0) {
      ElMessage.warning('没有可下载的安全校验日志');
      return;
    }
    downloadTextFile(buildTxtContent(rows), downloadFileName());
    ElMessage.success(`已生成 ${rows.length} 条安全校验日志`);
  } catch (error) {
    ElMessage.error('下载安全校验日志失败');
  } finally {
    downloadingTxt.value = false;
  }
}

function handleSearch() {
  page.value = 1;
  fetchLogs();
}

function refetchCurrentPage() {
  fetchLogs();
}

function handlePageSizeChange() {
  page.value = 1;
  fetchLogs();
}

function resetFilters() {
  filters.dateRange = defaultDateRange();
  filters.success = '0';
  filters.funcType = 'all';
  filters.sn = '';
  filters.vin = '';
  filters.modAddr = '';
  filters.securityType = 'all';
  filters.calcSource = 'all';
  page.value = 1;
  fetchLogs();
}

async function openRequestDrawer(row) {
  activeRequestId.value = row.request_id || '';
  requestRows.value = [];
  requestDrawerVisible.value = true;
  if (!activeRequestId.value) {
    return;
  }

  requestLoading.value = true;
  try {
    const response = await getFordSecurityCheckLogs(filters.server, {
      page: 1,
      page_size: 200,
      success: 'all',
      request_id: activeRequestId.value,
    });
    const payload = pickPayload(response);
    requestRows.value = Array.isArray(payload.tableData) ? payload.tableData : [];
  } catch (error) {
    ElMessage.error('查询同请求明细失败');
  } finally {
    requestLoading.value = false;
  }
}

onMounted(() => {
  fetchLogs();
});
</script>

<style scoped>
.security-log-panel {
  display: grid;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.panel-header,
.filter-section,
.table-section {
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid #dfe8f3;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(31, 56, 88, 0.05);
}

.panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
}

.panel-header h3,
.section-heading h4 {
  margin: 0;
  color: #132033;
  letter-spacing: 0;
}

.panel-header h3 {
  font-size: 18px;
}

.panel-header p,
.section-heading p {
  margin: 5px 0 0;
  color: #728196;
  font-size: 12px;
}

.filter-section {
  padding: 12px 14px;
  overflow: hidden;
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 10px;
  align-items: end;
}

.full-control,
.date-range {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.filter-form :deep(.el-form-item),
.filter-form :deep(.el-form-item__content),
.filter-form :deep(.el-select),
.filter-form :deep(.el-input),
.filter-form :deep(.el-date-editor) {
  min-width: 0;
  max-width: 100%;
}

.date-range :deep(.el-range-input) {
  min-width: 0;
}

.filter-actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  align-self: end;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 0;
  min-width: 0;
}

.filter-actions :deep(.el-button + .el-button) {
  margin-left: 0;
}

.stats-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  min-width: 0;
  max-width: 100%;
}

.stat-item {
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #dfe8f3;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(31, 56, 88, 0.04);
}

.stat-item span,
.stat-item strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stat-item span {
  color: #728196;
  font-size: 12px;
}

.stat-item strong {
  margin-top: 5px;
  color: #10233f;
  font-size: 18px;
}

.table-section {
  padding: 14px 16px 12px;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.section-heading {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.section-heading h4 {
  font-size: 15px;
}

.security-table,
.request-table {
  width: 100%;
  max-width: 100%;
}

.security-table :deep(.el-table__cell),
.request-table :deep(.el-table__cell) {
  vertical-align: top;
}

.security-table :deep(.el-table__expanded-cell) {
  padding: 0;
  background: #f8fafc;
}

.security-row-detail {
  padding: 12px 14px;
  border-top: 1px solid #e7eef7;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 14px;
}

.detail-item {
  min-width: 0;
  display: grid;
  grid-template-columns: 104px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
}

.detail-item-wide {
  grid-column: 1 / -1;
}

.detail-item span {
  color: #728196;
  font-size: 12px;
  line-height: 1.6;
}

.detail-item strong {
  min-width: 0;
  color: #132033;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.mono-value {
  font-family: Consolas, Monaco, monospace;
}

.detail-link {
  min-width: 0;
  justify-content: flex-start;
  height: auto;
  padding: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}

.pagination-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.request-drawer {
  min-height: 260px;
}

@media (max-width: 1180px) {
  .filter-grid,
  .stats-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .filter-grid,
  .stats-strip {
    grid-template-columns: 1fr;
  }

  .panel-header {
    flex-direction: column;
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }

  .detail-item {
    grid-template-columns: 88px minmax(0, 1fr);
  }
}
</style>
